import React from 'react'
import Navbar from '../inc/Navbar'
import Slider from '../inc/Slider'
import "./Home.css";
import Room from './Room';
import ScrollToTop from "react-scroll-to-top";
import Aboutus from './Aboutus';
import SlideButton from './SlideButton';
import Seminar from './Seminar';
import LiveCalender from './LiveCalender';
import PhotoSlider from './PhotoSlider';
import Googlemap from './Googlemap';
function Home() {
  return (
    <div>
        <Navbar/>
        <br/>
        <br/>
          <br/>
            <br/>
            <br/>
                <div className='album py-0'>
            <div className='container'>
              <div className="row">
                <div className="col-md-8 mt-2" >
                   <Slider/>
                  </div>
                      <div className="col-md-4 mt-2" >
                          <div
                  style={{
                    height: '350px',
                    overflowY: 'scroll',
                    border: '1px solid #ccc',
                    padding: '1rem',
                  }}
                >
                  <div className='backhome'>
                       <LiveCalender/>
                  </div>

                </div>
                
                  </div>
                  </div>
                  </div>
                </div>
                <br/>
       
       
    <ScrollToTop Smooth top="100" color="#48340A"/>
         <div className='krishnagarhotel marquee'>
        <div className="album py-1">
          <div className="container mt-2">
            <div className="row">
              <marquee>
                <h5 style={{ color: "#48340A" }} className=''>Welcome to LODGE GREEN HOUSE, Sadar Hospital More, Krishnanagar, Nadia, Pin - 741101, West Bengal, India</h5>
              </marquee>
            </div>
          </div>
        </div>
      </div>

        <div style={{ color: "white", padding: "14px;", margin: 10 }} className="fixed-bottom "> <a style={{ color: "white" }} href="tel: 8798265619" className="seminarcall" > <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-phone" viewBox="0 0 16 16">
        <path d="M11 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h6zM5 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H5z" />
        <path d="M8 14a1 1 0 1 0 0-2 1 1 0 0 0 0 2z" />
      </svg> Call Us <div className="spinner-grow text-light spinner-grow-sm" role="status">
          <span className="visually-hidden"> Loading...</span>
        </div> </a></div>
        <SlideButton/>
        <Aboutus/>
        <hr className='mb-0'/>
              <PhotoSlider/>
          <div className='sadarkrishnagar'>
              <br/>
          <Room/>
              <div className="fixedimage">
        <center>
          <div className='album py-0'>
            <div className='container'>
              <div className="row">
                <div className="col-md-12 mt-8" >
                  <div class="card border-danger mb-3">
                   <div className="alert alert-primary mb-0" role="alert">
    
<div className="album py-4">
        
        <div className="container">
            <div className="row">
            <div className="col-md-12">

            <h2 className="card-text"> <b>Contact Us</b></h2>
                                <h6 className="card-text"> Book Call : <a href='tel: 8798265619'>8798265619</a></h6>
</div>
</div>
</div>
</div>
</div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="sentancestyle">

            <h1><b>Lodge Green House </b></h1><br />
          </div>
          <div className="sentancestyles">
            <p>Enjoy a relaxing and peaceful stay designed for your complete comfort</p>
          </div>
        </center>
      </div>
          <br/>
       
          </div>

             <Seminar/>
             <br/>
             <Googlemap/>
             <br/>
        
    </div>
  )
}

export default Home